import service from "@/api/service";
import { GetResponse } from "@/api/stripe-confirm/response";
import { GetRequest } from "@/api/stripe-confirm/request";

/**
 * Stripe確認APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/stripe-confirm", getRequest);
  return response.data as GetResponse;
}
